export default "__VITE_ASSET__Dzg17A9P__"